import React from "react";
import MissionInfoDeductions from "../../components/viewers/MissionInfoDeductions";
import { StackScreenProps } from "@react-navigation/stack";
import { RootStackParamList } from "../../navigations/RootNavigation";

type Props = StackScreenProps<RootStackParamList, "MissionInfoDeductions">;

const MissionInfoDeductionsScreen: React.FC<Props> = ({ route }) => {
    return (
        route.params.deductions && <MissionInfoDeductions deductions={route.params.deductions} />
    );
};

export default MissionInfoDeductionsScreen;
